import config from 'app/config';
import request from 'superagent';
import { getUserToken } from 'services/authentication';

export default email =>
  new Promise((resolve, reject) => {
    const apiHost = config.get('AUTH_HOST');
    const endpoint = `${apiHost}/v1/users/by-provider/email/${email}`;

    request
      .get(endpoint)
      .set('Authorization', `Bearer ${getUserToken()}`)
      .end((err, res) => {
        if (err) {
          return reject(err);
        }
        return resolve(res.body);
      });
  });
